<script lang="ts">
	import {
		addMailTemplate,
		deleteMailTemplate,
		getMailTemplates,
		updateMailTemplate,
		updateMailTemplateSender
	} from './MailTemplateConfig.controller'
	import Basic from '../../templates/Basic.svelte'
	import MailTemplateEntry from './MailTemplateEntry.svelte'
	import { setContext } from 'svelte'
	import dayjs from 'dayjs'
	import { t } from '$i18n/i18n'
	import InputField from '../../molecules/InputField.svelte'
	import PrimaryButton from '../../atoms/PrimaryButton.svelte'
	import SecondaryButton from '../../atoms/SecondaryButton.svelte'
	import { ButtonIcons } from '$types/enums'
	import { modals } from 'svelte-modals'
	import MailTemplateEntryModal from './MailTemplateEntryModal.svelte'
	import { closeModalOnOutsideClick } from '#lib/stores.js'
	import Modal from '../../organisms/Modal.svelte'

	setContext('useMaterialDesign', true)
	let reload = {}
	let searchTerm = ''

	function addMapping() {
		$closeModalOnOutsideClick = true
		modals.open(MailTemplateEntryModal, {
			isOpen: true,
			entry: { id: 'new', mailName: '', mailTemplateId: '', daysUntilDeletion: null },
			title: 'Neuen Eintrag hinzufügen',
			onAccept: (entry) => addMailTemplate(entry, () => (reload = {})),
			acceptText: 'Eintrag erstellen'
		})
	}

	function updateMapping(oldEntry) {
		$closeModalOnOutsideClick = true
		modals.open(MailTemplateEntryModal, {
			isOpen: true,
			entry: oldEntry,
			title: 'Eintrag bearbeiten',
			onAccept: (entry) => updateMailTemplate(entry, () => (reload = {})),
			acceptText: 'Aktualisieren'
		})
	}

	function deleteMapping(entryId) {
		deleteMailTemplate(entryId, () => (reload = {}))
	}

	function updateMailTemplateSenderAndShowResult() {
		updateMailTemplateSender((message) => {
			modals.open(Modal, {
				isOpen: true,
				title: 'Sender aktualisiert',
				message: message,
				onAccept: modals.close,
				acceptText: 'OK',
				denyDisabled: true
			})
		})
	}
</script>

<Basic showLoadingAnimation={false} maxWidth="2160px" backgroundColor="#f5f5f5">
	<div class="mail-template-config">
		<div class="mail-template-config__header">
			<div class="mail-template-config__header--info">
				<h1>{$t('UI.MailConfig.header')}</h1>
				<h1>{dayjs().format('DD.MM.YYYY')}</h1>
			</div>
		</div>
		<div class="mail-template-config__search">
			<InputField bind:value={searchTerm} label={$t('UI.placeholder.search')} />
			<PrimaryButton
				label={$t('UI.chipList.addEntry')}
				leftIcon={ButtonIcons.PLUS_BOLD}
				on:click={addMapping}
				whiteIcon
			/>
			<SecondaryButton
				label={$t('UI.MailTemplates.refreshSender')}
				on:click={updateMailTemplateSenderAndShowResult}
			/>
		</div>
		<div class="mail-template-config__container">
			{#key reload}
				{#await getMailTemplates()}
					{#each Array(9)}
						<MailTemplateEntry loadingMode />
					{/each}
				{:then entries}
					<MailTemplateEntry headerMode />
					{#each entries.sort((a, b) => a.mailName.localeCompare(b.mailName)) as entry}
						{#if entry?.mailName
							?.toLowerCase()
							.includes(searchTerm.toLowerCase()) || entry?.mailTemplateId
								?.toLowerCase()
								.includes(searchTerm.toLowerCase())}
							<MailTemplateEntry {entry} onEdit={updateMapping} onDelete={deleteMapping} />
						{/if}
					{/each}
				{/await}
			{/key}
		</div>
	</div>
</Basic>

<style lang="scss">
	@use '$styles/global';
	@use '$styles/breakpoints';

	.mail-template-config {
		@include global.flex-col($justify: flex-start);
	}

	.mail-template-config__header {
		width: 100%;

		@include global.flex-col;
	}

	.mail-template-config__header--info {
		width: 100%;

		@include global.flex-row(0.75rem, $justify: space-between);

		margin-bottom: 1.875rem;

		h1 {
			color: global.$primaryGreen;
			font-size: 0.825rem;
			margin-bottom: 0;
		}
	}

	.mail-template-config__container {
		@include global.flex-col($justify: flex-start, $alignment: flex-start);

		width: 100%;
		flex-wrap: wrap;
	}

	@media screen and (min-width: breakpoints.$small) {
		.mail-template-config__header--info {
			h1 {
				color: global.$primaryGreen;
				font-size: 1.25rem;
			}
		}

		.mail-template-config__search {
			align-self: flex-start;

			@include global.flex-row(0.625rem, $justify: flex-start);

			width: 100%;
			max-width: 7600px; /* the single dropdown fields should not be longer than 255px */
			margin-bottom: 2.25rem;
		}
	}
</style>
